export const isFirefox = navigator.userAgent.toLowerCase().includes('firefox');